import SideBar from "./sidebar";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="dashboardFlexContainer">
      <SideBar />
      <main className="dashboardContainer" >
        <Outlet />
        <footer>
          Copyright @{currentYear} Fresh Fruit Agency | All rights reserved
        </footer>
      </main>
    </div>
  );
};

export default DashboardLayout;
